var map = {
	"./1729353259407.jpg": 7367,
	"./3kg Hubbard Squash.jpg": 1120,
	"./Butternut Joburg.jpeg": 9723,
	"./Butternut.jpg": 4953,
	"./Cabbage Novoton.jpg": 9528,
	"./Cabbage Packhouse Delivery.jpeg": 8333,
	"./Cabbages.jpeg": 4873,
	"./EggPlant.jpg": 9026,
	"./Garlic Processed.jpg": 2602,
	"./Hubbard Cut.jpg": 986,
	"./IMG-20250420-WA0005.jpg": 405,
	"./IMG-20250420-WA0007.jpg": 8615,
	"./IMG_20240729_100759.jpg": 8367,
	"./IMG_20241018_093731.jpg": 8490,
	"./IMG_20241025_115854.jpg": 5863,
	"./IMG_20241029_171640.jpg": 1832,
	"./Mustard Processed.jpg": 7436,
	"./Mustard.jpg": 292,
	"./Okra Clean.jpg": 1466,
	"./Okra Field.jpg": 7513,
	"./Onion Harvest 1.jpg": 8055,
	"./Onions.jpg": 2846,
	"./Pumpkin.jpeg": 4731,
	"./Seed Red Beans.jpg": 6287,
	"./Spinach JHB Market.jpg": 2748,
	"./Spinach PtaMkt.jpeg": 4988,
	"./Spinach.jpg": 1762,
	"./Turmerci 1.jpeg": 2123
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 2954;